import { createBrowserRouter } from "react-router-dom";
import { lazy, Suspense } from "react";
import App from "../../App";
import PrivateRoute from "../PrivateRoute";
import Animations from "../../components/animation/Animation";
import Layout from "../../components/layout/Layout";
import PrivateRouteModule from "../PrivateRouteModule";

const Caixa = lazy(() => import('../../pages/caixa/Caixa'));

const rotasCaixa = createBrowserRouter([
    {
        id: 'app-caixa',
        element: <App />,
        path: '/caixa',
        children: [
            {
                id: 'caixa',
                path: '',
                element: (
                    <Suspense fallback={<Animations />}>
                        <PrivateRoute>
                            <PrivateRouteModule>
                                <Layout titulo={'Caixa'}>
                                    <Caixa />
                                </Layout>
                            </PrivateRouteModule>
                        </PrivateRoute>
                    </Suspense>
                )
            }
        ]
    }
]);

export default rotasCaixa;